<template>
  <el-dialog
    class="dialog-inner-scroller"
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="1200"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          图片编辑
        </h4>
      </div>
    </template>

    <div
      id="editor_container"
      v-loading="saving"
      :element-loading-text="saving ? '上传中...' : ''"
      class="px-2 pb-3"
      style="height: 66vh"
    />
  </el-dialog>
</template>

<script setup lang="ts">
import { settings } from '@core/api';
import { loadScript } from '@core/tools';
import { watch } from 'vue';

const emit = defineEmits(['close', 'change']);

const props = defineProps({
  /** 是否显示编辑弹框 */
  visible: {
    type: Boolean,
    default: false,
  },
  /** 是否正在上传 */
  saving: {
    type: Boolean,
    default: false,
  },
  /** 图片地址或base64 */
  image: {
    type: String,
    default: '',
  },
});

async function initEditor() {
  await loadScript(
    settings.imageEditorScriptUrl,
    settings.imageEditorScriptKey,
  );

  const config = {
    source: props.image,
    onBeforeSave: () => false,
    onSave,
    tabsIds: ['Adjust'],
    defaultTabId: 'Adjust',
    defaultToolId: 'Rotate', // or 'Crop', 'Flip_X', 'Flip_Y', 'Rotate'
    useBackendTranslations: false,
    defaultSavedImageType: 'png',
    defaultSavedImageQuality: 1,
    avoidChangesNotSavedAlertOnLeave: true,
    Rotate: {
      angle: 90,
      componentType: 'buttons', // 'slider' | 'buttons'
    },
    Image: { disableUpload: true },
    translations: {
      save: '上传',
      cropTool: '裁剪',
      rotateTool: '旋转',
      flipTool: '翻转',
      flipX: '水平翻转',
      unFlipX: '水平翻转',
      flipY: '垂直翻转',
      unFlipY: '垂直翻转',
      custom: '自定义',
      original: '原始',
      landscape: '宽屏',
      portrait: '竖屏',
      ellipse: '椭圆',
      zoomInTitle: '放大',
      zoomOutTitle: '缩小',
      toggleZoomMenuTitle: '  ',
      imageDimensionsHoverTitle: '图片尺寸',
      undoTitle: ' ',
      redoTitle: ' ',
    },
  };

  const editor = new window.FilerobotImageEditor(
    document.querySelector('#editor_container'),
    config,
  );

  editor.render({
    onClose: () => {
      editor.terminate();
    },
  });
}

function onSave(imgObj: any) {
  emit('change', imgObj.imageBase64);
}

watch(
  [
    () => props.visible,
    () => props.image,
  ],
  ([newVisible, newImage]) => {
    if (newVisible && newImage) {
      initEditor();
    }
  },
);
</script>

<style lang="scss">
.FIE_topbar-reset-button {
  display: none !important;
  border-bottom: none !important;
}

.FIE_topbar {
  border-bottom: none !important;
}

.FIE_tabs {
  display: none !important;
}

.FIE_topbar-save-wrapper {
  position: absolute !important;
  right: 0 !important;
}

.FIE_topbar-save-button {
  background-color: var(--color-primary) !important;
  color: #fff !important;

  &:hover {
    background-color: var(--color-primary-active) !important;
  }
}

.FIE_topbar {
  padding: 16px 87px 16px 16px !important;
}

.FIE_canvas-container {
  padding: 0 !important;
}

.FIE_tools-bar-wrapper {
  padding-top: 20px !important;
}

.FIE_canvas-node {
  background-image: linear-gradient(45deg, #f0f0f0 25%, transparent 25%), linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f0f0f0 75%), linear-gradient(-45deg, transparent 75%, #f0f0f0 75%) !important;
  background-size: 20px 20px !important;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px !important;
}

.FIE_topbar-close-button {
  display: none !important;
  padding-left: 30px !important;
}

.FIE_crop-presets-opener-button,
.FIE_crop-presets-menu {
  display: none !important;
}
</style>
